import Cookies from "js-cookie";
import React from "react";
import { Redirect, Route } from "react-router-dom";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const user = Cookies.get("user");

      console.log("user", user);

      if (!user) {
        return <Redirect to="/login" />;
      }

      return <Component {...props} />;
    }}
  />
);

export default PrivateRoute;
